import { StatusEnum } from "./status-enum";

export const statusLabels = {
  [StatusEnum.UNPAID]: "Belum Lunas",
  [StatusEnum.PARTIALLY_PAID]: "Lunas Sebagian",
  [StatusEnum.FULLY_PAID]: "Lunas",
};
